module.exports = window["lapilliUI"]["styles"];